import { formatSvgStr } from "@/common/svg"
import { useMemo } from "react"

interface SvgElemProps {
  imageStr: string
  className?: string
  svgClassName?: string
}

export const SvgElem = (props: SvgElemProps) => {
  const {imageStr, className, svgClassName} = props;
  const image = useMemo(() => {
    return formatSvgStr(imageStr, svgClassName)
  }, [imageStr, svgClassName])
  
  return <div dangerouslySetInnerHTML={{__html: image}} className={className} style={{width: '100%', height: '100%'}}></div>
}